<template>
  <div>
    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
      <p class="ck-subtitulo mb-0" style="max-width: 780px">
        Feriados, pontos facultativos, recessos e férias coletivas. No dia, quem tem jornada que <b>segue feriados</b>
        fica de folga (ou com o horário reduzido). Horas trabalhadas em feriado nacional, estadual ou municipal saem
        separadas no espelho de ponto. Para escalar alguém num feriado, use uma exceção em
        <router-link to="/escalas">Escalas e exceções</router-link>.
      </p>
      <div class="d-flex gap-2">
        <button class="btn btn-light" @click="abrirImportar"><i class="bi bi-cloud-download"></i> Importar nacionais</button>
        <button class="btn btn-info" @click="editar()"><i class="bi bi-plus-lg"></i> Novo feriado</button>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body py-2 d-flex flex-wrap gap-2 align-items-center">
        <div class="input-group" style="width: 190px">
          <button class="btn btn-light" @click="ano--" title="Ano anterior"><i class="bi bi-chevron-left"></i></button>
          <span class="form-control text-center fw-bold">{{ ano }}</span>
          <button class="btn btn-light" @click="ano++" title="Próximo ano"><i class="bi bi-chevron-right"></i></button>
        </div>
        <select v-model="filtroFilial" class="form-select" style="max-width: 280px" @change="carregar">
          <option value="">Todas as filiais</option>
          <option v-for="f in filiais" :key="f.id" :value="f.id">{{ f.text }}</option>
        </select>
        <span class="ms-auto small text-muted">{{ lista.length }} data(s) em {{ ano }}</span>
      </div>
    </div>

    <div v-if="carregando" class="text-center py-5"><span class="spinner-border"></span></div>
    <div v-else-if="!lista.length" class="card">
      <div class="card-body text-center py-5">
        <i class="bi bi-calendar-heart" style="font-size: 2.4rem; color: var(--ck-primaria)"></i>
        <h5 class="mt-2">Nenhum feriado em {{ ano }}</h5>
        <p class="ck-subtitulo">Comece importando os feriados nacionais e depois cadastre os estaduais e municipais de cada filial.</p>
        <button class="btn btn-info" @click="abrirImportar">Importar feriados nacionais de {{ ano }}</button>
      </div>
    </div>

    <div v-else class="card">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0 feriados">
          <thead>
            <tr><th>Data</th><th>Feriado</th><th>Tipo</th><th>Abrangência</th><th>No dia</th><th style="width: 96px"></th></tr>
          </thead>
          <tbody>
            <template v-for="(grupo, mes) in porMes" :key="mes">
              <tr class="mes"><td colspan="6">{{ MESES[mes] }}</td></tr>
              <tr v-for="f in grupo" :key="f.id" :class="{ passado: (f.datafim && !f.recorrente ? f.datafim : f.data_ano) < hoje }">
                <td class="text-nowrap">
                  <b>{{ dataCurta(f.data_ano) }}</b><span v-if="f.datafim && !f.recorrente"> a {{ dataCurta(f.datafim) }}</span>
                  <small class="text-muted ms-1">{{ f.dia.substring(0, 3) }}</small>
                </td>
                <td>
                  {{ f.nome }}
                  <span v-if="f.recorrente" class="badge badge-suave ms-1" title="Repete todo ano"><i class="bi bi-arrow-repeat"></i> anual</span>
                </td>
                <td><span :class="['badge', CORES[f.tipo]]">{{ f.tipo_nome }}</span></td>
                <td class="small">{{ f.nomefilial }}</td>
                <td class="small">{{ f.efeito === 'H' ? f.horario : 'Folga' }}</td>
                <td class="text-end text-nowrap">
                  <button class="btn btn-sm btn-light" @click="editar(f)" title="Editar"><i class="bi bi-pencil"></i></button>
                  <button class="btn btn-sm btn-light text-danger ms-1" @click="excluir(f)" title="Excluir"><i class="bi bi-trash"></i></button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal: cadastro -->
    <div class="modal fade" ref="mFer" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ form.id ? 'Editar feriado' : 'Novo feriado' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div class="modal-body">
            <div class="row g-2">
              <div class="col-12">
                <label>Nome</label>
                <input v-model.trim="form.nome" maxlength="80" class="form-control" placeholder="Ex.: Aniversário de Belém, Recesso de fim de ano">
              </div>
              <div class="col-6">
                <label>Tipo</label>
                <select v-model="form.tipo" class="form-select">
                  <option value="N">Nacional</option>
                  <option value="E">Estadual</option>
                  <option value="M">Municipal</option>
                  <option value="P">Ponto facultativo</option>
                  <option value="X">Da empresa (recesso, coletivas)</option>
                </select>
              </div>
              <div class="col-6">
                <label>Vale para</label>
                <select v-model="form.idfilial" class="form-select">
                  <option :value="null">Todas as filiais</option>
                  <option v-for="f in filiais" :key="f.id" :value="f.id">{{ f.text }}</option>
                </select>
              </div>
              <div class="col-6">
                <label>{{ form.recorrente ? 'Data (dia/mês)' : 'Data' }}</label>
                <input type="date" v-model="form.data" class="form-control">
              </div>
              <div class="col-6" v-if="!form.recorrente">
                <label>Até (período, opcional)</label>
                <input type="date" v-model="form.datafim" :min="form.data" class="form-control">
              </div>
              <div class="col-12">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="ferrec" v-model="form.recorrente" @change="form.recorrente && (form.datafim = '')">
                  <label class="form-check-label m-0" for="ferrec">Repete todo ano na mesma data</label>
                </div>
                <small class="text-muted" v-if="form.recorrente">Vale a partir do ano da data informada.</small>
              </div>
              <div class="col-12 mt-2">
                <label>No dia</label>
                <div class="btn-group w-100" role="group">
                  <button type="button" :class="['btn', form.efeito === 'F' ? 'btn-info' : 'btn-light']" @click="form.efeito = 'F'">
                    <i class="bi bi-cup-hot"></i> Folga
                  </button>
                  <button type="button" :class="['btn', form.efeito === 'H' ? 'btn-info' : 'btn-light']" @click="form.efeito = 'H'">
                    <i class="bi bi-clock"></i> Horário reduzido
                  </button>
                </div>
              </div>
              <template v-if="form.efeito === 'H'">
                <div class="col-6 col-md-3"><label>Entrada</label><input type="time" v-model="form.hora_entrada" class="form-control"></div>
                <div class="col-6 col-md-3"><label>Início int.</label><input type="time" v-model="form.hora_inicio_intervalo" class="form-control"></div>
                <div class="col-6 col-md-3"><label>Fim int.</label><input type="time" v-model="form.hora_fim_intervalo" class="form-control"></div>
                <div class="col-6 col-md-3"><label>Saída</label><input type="time" v-model="form.hora_saida" class="form-control"></div>
                <div class="col-12"><small class="text-muted">Ex.: Quarta-feira de Cinzas a partir das 14h, véspera de Natal até o meio-dia. Só muda quem trabalharia no dia.</small></div>
              </template>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <button class="btn btn-info" @click="salvar" :disabled="salvando">Salvar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: importar nacionais -->
    <div class="modal fade" ref="mImp" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Feriados nacionais de {{ ano }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div class="modal-body">
            <p class="small text-muted mb-2">
              As datas fixas entram como anuais. Carnaval e Corpus Christi entram como ponto facultativo.
              Desmarque o que a empresa não concede. Estaduais e municipais você cadastra por filial.
            </p>
            <div v-if="!nacionais.length" class="text-center py-3"><span class="spinner-border spinner-border-sm"></span></div>
            <label v-for="n in nacionais" :key="n.data" class="imp-item" :class="{ existe: n.existe }">
              <input type="checkbox" class="form-check-input me-2" v-model="n.marcado" :disabled="n.existe">
              <span class="data">{{ dataCurta(n.data) }} <small>{{ n.dia.substring(0, 3) }}</small></span>
              <span class="flex-fill">{{ n.nome }}</span>
              <span v-if="n.existe" class="badge text-bg-light">já cadastrado</span>
              <span v-else :class="['badge', CORES[n.tipo]]">{{ n.tipo === 'P' ? 'facultativo' : 'nacional' }}</span>
            </label>
          </div>
          <div class="modal-footer">
            <button class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <button class="btn btn-info" @click="importar" :disabled="salvando || !nacionais.some(n => n.marcado && !n.existe)">
              Importar {{ nacionais.filter(n => n.marcado && !n.existe).length }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);
import Swal from 'sweetalert2'
import axios from 'axios'
import { Modal } from 'bootstrap'
import util from '@/util'

const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
const CORES = { N: 'text-bg-success', E: 'text-bg-primary', M: 'text-bg-info', P: 'text-bg-warning', X: 'text-bg-secondary' }

function iso(d) { return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().substring(0, 10) }

export default {
  name: 'FeriadosView',
  data() {
    return {
      MESES, CORES,
      hoje: iso(new Date()),
      ano: new Date().getFullYear(),
      filtroFilial: '',
      lista: [],
      filiais: [],
      nacionais: [],
      carregando: false,
      salvando: false,
      modais: {},
      form: this.novoForm(),
    }
  },
  computed: {
    porMes() {
      const g = {}
      this.lista.forEach(f => {
        const m = parseInt(f.data_ano.substring(5, 7)) - 1
        ;(g[m] = g[m] || []).push(f)
      })
      return g
    },
  },
  watch: {
    ano() { this.carregar() },
  },
  mounted() {
    this.carregar()
    this.carregarFiliais()
  },
  beforeUnmount() {
    Object.values(this.modais).forEach(m => m.dispose())
  },
  methods: {
    dataCurta(v) { return util.dataBR(v).substring(0, 5) },
    novoForm() {
      return { id: 0, nome: '', tipo: 'M', idfilial: null, data: '', datafim: '', recorrente: true, efeito: 'F',
               hora_entrada: '08:00', hora_inicio_intervalo: '', hora_fim_intervalo: '', hora_saida: '12:00' }
    },
    modal(nome) {
      if (!this.modais[nome]) this.modais[nome] = new Modal(this.$refs[nome])
      return this.modais[nome]
    },
    req(op, extra = []) {
      return util.reqaxios([{ parametro: 'op', valor: op }, { parametro: 'idempresa', valor: this.$store.state.usuario.idempresa }, ...extra],
                           'post', util.servidor + '/controller/feriados.php')
    },
    async carregar() {
      this.carregando = true
      try {
        const extra = [{ parametro: 'ano', valor: this.ano }]
        if (this.filtroFilial !== '') extra.push({ parametro: 'idfilial', valor: this.filtroFilial })
        const r = await this.req('listagem', extra)
        this.lista = Array.isArray(r.data) ? r.data : []
        if (!Array.isArray(r.data)) util.respostaOk(r.data)
      } finally {
        this.carregando = false
      }
    },
    async carregarFiliais() {
      const r = await axios.get(util.servidor + '/controller/select2sql.php', {
        params: { idempresa: this.$store.state.usuario.idempresa, token: util.token(), tabela: 'tbfiliais' },
      }).catch(() => ({ data: [] }))
      this.filiais = Array.isArray(r.data) ? r.data : []
    },
    editar(f) {
      this.form = f
        ? { id: f.id, nome: f.nome, tipo: f.tipo, idfilial: f.idfilial, data: f.data, datafim: f.datafim || '', recorrente: !!f.recorrente,
            efeito: f.efeito, hora_entrada: f.hora_entrada || '08:00', hora_inicio_intervalo: f.hora_inicio_intervalo,
            hora_fim_intervalo: f.hora_fim_intervalo, hora_saida: f.hora_saida || '12:00' }
        : { ...this.novoForm(), data: this.ano + this.hoje.substring(4) }
      this.modal('mFer').show()
    },
    async salvar() {
      const f = this.form
      if (!f.nome) return util.notif('error', 'Atenção', 'Informe o nome.')
      if (!f.data) return util.notif('error', 'Atenção', 'Informe a data.')
      if (f.efeito === 'H' && (!f.hora_entrada || !f.hora_saida)) return util.notif('error', 'Atenção', 'Informe entrada e saída do horário reduzido.')
      this.salvando = true
      try {
        const r = await this.req('salvar', [{ parametro: 'registro', valor: JSON.stringify({ ...f, recorrente: f.recorrente ? 1 : 0 }) }])
        if (util.respostaOk(r.data)) {
          this.modal('mFer').hide()
          util.notif('success', 'Feriado salvo', '')
          this.carregar()
        }
      } finally {
        this.salvando = false
      }
    },
    async excluir(f) {
      const ok = await Swal.fire({
        title: `Excluir "${f.nome}"?`,
        text: f.recorrente ? 'O feriado é anual: ele deixa de valer em todos os anos, inclusive nos espelhos já fechados.'
                           : 'Os espelhos de ponto dessa data voltam a usar a escala normal.',
        icon: 'warning', showCancelButton: true, confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar',
      })
      if (!ok.isConfirmed) return
      const r = await this.req('excluir', [{ parametro: 'id', valor: f.id }])
      if (util.respostaOk(r.data)) this.carregar()
    },
    async abrirImportar() {
      this.nacionais = []
      this.modal('mImp').show()
      const r = await this.req('nacionais', [{ parametro: 'ano', valor: this.ano }])
      this.nacionais = Array.isArray(r.data) ? r.data.map(n => ({ ...n, marcado: !n.existe })) : []
    },
    async importar() {
      this.salvando = true
      try {
        const datas = this.nacionais.filter(n => n.marcado && !n.existe).map(n => n.data)
        const r = await this.req('importar', [{ parametro: 'ano', valor: this.ano }, { parametro: 'datas', valor: JSON.stringify(datas) }])
        if (util.respostaOk(r.data)) {
          this.modal('mImp').hide()
          util.notif('success', r.data + ' feriado(s) importado(s)', '')
          this.carregar()
        }
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.feriados th { font-size: .72rem; text-transform: uppercase; color: var(--ck-texto-2); background: #f7faf9; letter-spacing: .04em; }
.feriados tr.mes td { background: #fbfcfc; font-weight: 700; font-size: .78rem; color: var(--ck-primaria); text-transform: uppercase; letter-spacing: .05em; padding-top: 10px; }
.feriados tr.passado td { color: #93a29d; }
.feriados tr.passado .badge { opacity: .6; }
.imp-item { display: flex; align-items: center; gap: 8px; padding: 7px 4px; border-bottom: 1px solid var(--ck-borda); cursor: pointer; font-size: .88rem; font-weight: 500; color: var(--ck-texto); width: 100%; margin: 0; }
.imp-item.existe { color: #93a29d; cursor: default; }
.imp-item .data { width: 70px; font-variant-numeric: tabular-nums; font-weight: 700; }
.imp-item .data small { font-weight: 500; color: var(--ck-texto-2); }
</style>
